import { ProductMenu } from '../product-menu';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { Section } from '../section/section';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { exists } from '../../../functions/exists';
import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class NorthernLights extends ProductMenu {
  getThemeClass(): string {
    return 'northern-lights';
  }

  getMenuWrapperClass(): string {
    if (this.isLandscape()) {
      return 'landscape-menu';
    } else {
      return 'vertical-menu';
    }
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Poppins.Medium_500,
      FONT.Shelby.Regular_400,
      FONT.Roboto.Regular_400,
      FONT.Roboto.SemiBold_600,
      FONT.Roboto.Medium_500
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/twj4vsr.css';
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getHeaderType(): Type<MenuHeaderTitleImageComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getTitleSectionTopMargin(): string {
    return '0';
  }

  getTitleSectionBottomMargin(): string {
    return '0';
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getShowFooter(): boolean {
    return false;
  }

  getShouldInflateColumnHeaderForRow(s: Section, col: SectionColumnViewModel, rows: SectionRowViewModel[]): boolean {
    const badge = col?.columnType === SectionColumnProductInfoType.Badge;
    return !badge || (badge && exists(col?.columnTitle));
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.Badge, 0],
      [SectionColumnProductInfoType.ProductTitle, 1],
      [SectionColumnProductInfoType.Label, 2],
      [SectionColumnProductInfoType.Strain, 3],
      [SectionColumnProductInfoType.StrainType, 4],
      [SectionColumnProductInfoType.Brand, 5],
      [SectionColumnProductInfoType.QuantityAndSize, 6],
      [SectionColumnProductInfoType.Quantity, 7],
      [SectionColumnProductInfoType.Size, 8],
      [SectionColumnProductInfoType.VariantType, 9],
      [SectionColumnProductInfoType.Stock, 10],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(11),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(12),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(13),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(14),
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }
}
